// internationalization
import { t } from 'i18next';

// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

// analysisType param ('power' | 'water' | 'heat')
export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/$analysisType',
)({
  component: Outlet,
  staticData: {
    crumb: ({ params }) => t(`glossary:${params.analysisType}`),
    // Overrides the parent portfolio route's flag - the app bar is shown
    // again for this analysis type and all of its descendant routes.
    hideEnergyAnalysisAppBar: false,
  },
});
